/**
 * For each parameter (facet field), define a merge group:
 * - key: target label to display
 * - values: source raw values that should map to it
 */
export const MERGE_FILTERS_MAP: Record<
  string, // e.g. "region", "state"
  Record<
    string, // canonical label, e.g. "texas"
    string[] // synonyms, e.g. ["tx", "texas", "texas"]
  >
> = {
  "region.keyword": {
    "california": ["california", "ca", "california usa"],
    "central valley": ["central valley", "central valley - chile"],
    "friuli-venezia giulia": ["friuli-venezia giulia", "friuli venezia-venezia giulia"],
    "highlands": ["highlands", "highland"],
    "st. emilion": ["st. emilion", "st.. emilion"],
    "texas": ["texas", "tx", "%^", "austin", "houston"],
  },
  "origin.keyword": {
    "georgia": ["georgia", "georgian"],
    "texas": ["texas", "tx"],
    "united kingdom": ["united kingdom", "uk", "u.k."],
    "united states": ["united states", "usa", "us", "u.s."],
  },
  "size.keyword": {
    "750ML": ["750ML","75OML"],
  },
};
